import React from 'react';
import { getLanguage, setLanguage, subscribeToLanguage, supportedLanguages } from './autoTranslate';

const SHORT_LABELS = { en: 'EN', ar: 'Ar', fr: 'Fr' };

export default function LanguageSwitcher({ compact = false, className = '' }) {
  const [language, setCurrentLanguage] = React.useState(getLanguage());

  React.useEffect(() => subscribeToLanguage(setCurrentLanguage), []);

  React.useEffect(() => {
    const floatingSwitcher = document.getElementById('ig-i18n-floating-language-switcher');
    if (floatingSwitcher) floatingSwitcher.remove();
  }, []);

  return (
    <label
      data-i18n-language-switcher
      data-i18n-ignore
      className={`inline-flex max-w-full items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.06] px-2 py-1.5 text-xs text-white/80 shadow-[0_10px_30px_rgba(0,0,0,.18)] backdrop-blur-xl sm:gap-2 sm:px-2.5 ${className}`}
    >
      <span aria-hidden="true" className="text-sm">🌐</span>
      {!compact && <span className="font-medium">Language</span>}
      <select
        aria-label="Language"
        value={language}
        onChange={(event) => setLanguage(event.target.value)}
        className="min-w-[58px] cursor-pointer rounded-full border border-white/10 bg-black/30 px-2 py-1 text-xs font-semibold text-white outline-none transition hover:bg-white/10"
      >
        {supportedLanguages.map((item) => (
          <option key={item.code} value={item.code} className="bg-[#0B0B12] text-white">
            {compact ? (item.shortLabel || SHORT_LABELS[item.code] || item.code.toUpperCase()) : item.nativeLabel}
          </option>
        ))}
      </select>
    </label>
  );
}
